import r from "../factory.js";
import { nowTimestamp as a } from "../utils.js";
import { startOfYear as m } from "../../utils.js";
const s = r({
  from: ({ now: t, timezone: o }) => m(t, o),
  to: a
});
export {
  s as default
};
